import { useState } from "react";
import { auth } from "../firebase/firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import { InfoPageLayout } from "../Layouts/InfoPageLayout";
import { useUtility } from "../contexts/auth/UtilityContext";
import { ToastMessage } from "../components/Toasts/ToastArea";
import { Link } from "react-router-dom";

export function ResetPasswordPage() {
    const [email, setEmail] = useState('');

    const { setNewToast } = useUtility();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            await sendPasswordResetEmail(auth, email);
            setNewToast({ title: "Password Reset", message: "Check your email for the reset link.", toastType: "success" } as ToastMessage);
            setEmail('');
        } catch (error : any) {
            setNewToast({ title: "Error", message: error.message, toastType: "error" } as ToastMessage);
        }
    };

    return (
    <InfoPageLayout>
        <main className="flex flex-1 self-center place-content-center place-items-center page-hp">
            <div className="w-96 text-gray-600 space-y-5 p-4 shadow-xl border rounded-xl">
                <div className="text-center">
                    <div className="mt-2">
                        <h3 className="text-gray-800 text-xl font-semibold sm:text-2xl">Reset Password</h3>
                    </div>
                </div>
                <div>
                    <form onSubmit={handleSubmit}>
                        <div>
                            <label className="text-sm text-gray-600 font-bold">
                                Email
                            </label>
                            <input
                                type="email"
                                autoComplete='email'
                                required
                                value={email} onChange={(e) => { setEmail(e.target.value) }}
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
                            />
                        </div>
                        <br />
                    </form>
                    <p className="text-sm">Back to <Link to={'/login'} className="hover:underline font-bold">login</Link></p>
                    <button
                        type="submit"
                        onClick={handleSubmit}
                        className={`w-full px-4 py-2 text-white font-medium rounded-lg bg-indigo-600 hover:bg-indigo-700 hover:shadow-xl transition duration-300 mt-4`}
                    >
                        Reset Password
                    </button>
                </div>
            </div>
        </main>
    </InfoPageLayout>
  );
}